import { httpCreate } from './http';

const http = httpCreate('/srv/game-activity');

export const game = {
	createGame(activityId, body, params) {
		return http.post(`/${activityId}`, body, { params });
	},
	editGame(activityId, body, params) {
		return http.put(`/${activityId}`, body, { params });
	},
	gameList(activityId, params) {
		return http.get(`/list/${activityId}`, { params });
	},
	getGameDetail(gameActivityId) {
		return http.get(`info/${gameActivityId}`);
	},
	deleteGame(gameActivityId) {
		return http.delete(`/${gameActivityId}`);
	},
	// 开启游戏
	openGame(gameActivityId) {
		return http.put(`/${gameActivityId}/ready`);
	},
	// 获取小游戏下拉列表(只有已完成的)
	getGameOptions(activityId, gameType) {
		return http.get(`/${activityId}/list?gameType=${gameType}`);
	},
	// 获取限制名单
	getLimitList(activityId, params) {
		return http.get(`/limit/${activityId}`, { params });
	},
	// 解除限制
	cancelLimit(activityId, params, limitIdList) {
		return http.delete(`/limit/${activityId}`, { params, data: limitIdList });
	},
	// 解除所有人限制
	cancelLimitAll(actiivtyId, params) {
		return http.delete(`/limit/all/${actiivtyId}`, { params });
	},
};
